<div  class="container-fluid container-fluid-wrap">
        <br /><br />

  <div class="row">
  
      <div class="col-sm-2 col-md-3"></div>
  
      <div class="col-xs-12 col-sm-8 col-md-6">
  
        <sync-error [errcode]="errcode"></sync-error>
 
  
        <div class="panel panel-default animated bounceInDown">
  
          <div class="panel-heading">
  
          <h3 class="panel-title" *ngIf="!twofarequired"><i class="ion-android-person fa-lg"></i> Single sign on</h3>
          <h3 class="panel-title" *ngIf="twofarequired"><i class="ion-locked fa-lg"></i> 2-FA</h3>
          </div>
  
          <div class="panel-body">
  
          <form (submit)="submit()" ngNativeValidate>
              <div *ngIf="!twofarequired">
                  <p>Attempting to log you in to the Control Panel.  If this hasn't happened
                      yet, <a routerLink="/login"  class="syncblue showhand">log in manually</a>
                  </p>
              </div>
              <div class="form-group" *ngIf="twofarequired">
                  <label>Two factor authentication Code:</label>
                  <div class="input-group">
                      <input
                      type="text"
                      [(ngModel)]="twofacode"
                      class="form-control"
                      id="twofacode"
                      name="twofacode"
                      />
                      <span class="input-group-btn">
                      <button
                      type="submit"
                      class="btn btn-primary"
                          >Log in <i class="fa fa-chevron-right"></i>
                      </button>
                      </span>
                  </div>
              </div>
  
          </form>
  
          </div>
  
          <div class="panel-footer text-left">
          </div>
          </div> <!-- end panel -->
  
      <div class="col-sm-2 col-md-3"></div>
  
      </div>
  
  </div>
  
  </div>
  